import type { Recommendation } from '@lizrd/contracts';

/**
 * When the customer has accepted the NIS2-compliant alternative on a guarded
 * optimization, the headline saving and action should reflect that alternative
 * (e.g. "keep Multi-AZ, downsize one class") rather than the original, more
 * aggressive change. Returns the re-estimated figures, or null when no alternative
 * is applied or the alternative has no distinct estimate.
 */
export function appliedAlternative(
  rec: Pick<Recommendation, 'complianceAlternativeApplied' | 'complianceFlags'>,
): { saving: number; basis: string | null } | null {
  if (!rec.complianceAlternativeApplied) return null;
  const flag = (rec.complianceFlags ?? []).find((f) => f.compliantAlternativeSaving != null);
  if (!flag || flag.compliantAlternativeSaving == null) return null;
  return {
    saving: flag.compliantAlternativeSaving,
    basis: flag.compliantAlternativeBasis ?? null,
  };
}
